import { createAction, props } from "@ngrx/store";
import { User } from "src/app/auth/model/user";

export const setUser = createAction("[Login Component] set user", props<{ user: User }>());
export const updateUser = createAction("[Auth] Update User", props<{ user: User }>());
export const updateSettings = createAction("Update Settings", props<{ settings: string }>());
export const resetUser = createAction("[ANY Component] Reset");
